/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConnection = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 4a8.008 8.008 0 0 1 6.565 3.428l-1.64 1.144A6.013 6.013 0 0 0 12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6a6.031 6.031 0 0 0 5.423-3.429l1.806.858A8.039 8.039 0 0 1 12 20c-4.072 0-7.444-3.059-7.938-7H2v-2h2.062C4.556 7.06 7.927 4 12 4zm0 5c1.304 0 2.416.836 2.829 2H22v2h-7.172A3.006 3.006 0 0 1 12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3zm0 2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgConnection as Connection };
